import { useState } from "react";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";
import { Copy } from "@phosphor-icons/react";

const BE = process.env.REACT_APP_BACKEND_URL;
const SCIM_BASE = `${BE}/api/scim/v2`;

export default function ScimSettings() {
  const [, setCopied] = useState("");
  const copy = (v, k) => { navigator.clipboard.writeText(v); setCopied(k); toast.success("Copied"); };
  const Row = ({ label, value, k }) => (
    <div className="flex items-center gap-3 py-2 border-b border-border/60">
      <div className="w-56 text-[11px] font-mono uppercase text-muted-foreground">{label}</div>
      <code className="flex-1 text-xs font-mono text-primary break-all">{value}</code>
      <button data-testid={`copy-${k}`} onClick={() => copy(value, k)} className="text-muted-foreground hover:text-primary"><Copy size={14} /></button>
    </div>
  );
  return (
    <div className="p-6" data-testid="scim-view">
      <div className="mb-6">
        <div className="text-[11px] font-mono uppercase tracking-widest text-primary mb-1">Enterprise Identity</div>
        <h1 className="font-display text-3xl sm:text-4xl font-black">SCIM Provisioning</h1>
        <p className="text-sm text-muted-foreground mt-2 max-w-2xl">Sign-in uses Microsoft Entra ID (OAuth 2.0 / OpenID Connect). Use SCIM 2.0 below to automatically provision and deprovision users from Entra.</p>
      </div>

      <div className="grid grid-cols-1 gap-4">
        <Card className="p-6 border-border rounded-sm">
          <div className="text-[11px] font-mono uppercase tracking-widest text-primary mb-2">SCIM 2.0</div>
          <div className="font-display text-lg mb-3">Automated provisioning</div>
          <ol className="text-sm text-muted-foreground list-decimal list-inside space-y-1 mb-4">
            <li>Entra Admin Center → your TRAK enterprise app → Provisioning → Automatic</li>
            <li>Tenant URL: paste the value below</li>
            <li>Secret Token: paste the SCIM bearer (from backend <code>.env</code> <code>SCIM_TOKEN</code>)</li>
            <li>Test connection → Save</li>
          </ol>
          <Row label="SCIM Tenant URL" value={SCIM_BASE} k="scim-url" />
          <Row label="ServiceProviderConfig" value={`${SCIM_BASE}/ServiceProviderConfig`} k="scim-cfg" />
          <Row label="Users endpoint" value={`${SCIM_BASE}/Users`} k="scim-users" />
        </Card>
      </div>

      <Card className="p-6 border-border rounded-sm mt-4">
        <div className="text-[11px] font-mono uppercase tracking-widest text-primary mb-2">Environment Configuration</div>
        <div className="font-display text-lg mb-3">Backend .env key</div>
        <pre className="text-xs font-mono text-muted-foreground whitespace-pre-wrap bg-muted p-4 rounded-sm">SCIM_TOKEN=&lt;generate a strong token&gt;</pre>
        <p className="text-xs text-muted-foreground mt-3">Rotate this token periodically. It authenticates Entra's provisioning requests to the SCIM endpoints.</p>
      </Card>
    </div>
  );
}
